export const API_RESPONSE_ERROR_TEXT = {
  INSUFFICIENT_BALANCE: 'Insufficient balance',
  UNSUPPORTED_COUNTRY: 'Unsupported Country',
  ACCESS_DENIED: 'access_denied'
}

export const COGNITO_ERRORS = {
  USERNAME_EXISTS_EXCEPTION: 'UsernameExistsException',
  USER_NOT_CONFIRMED_EXCEPTION: 'UserNotConfirmedException',
  EXPIRED_CODE_EXCEPTION: 'ExpiredCodeException',
  CODE_MISMATCH_EXCEPTION: 'CodeMismatchException',
  ALIAS_EXISTS_EXCEPTION: 'AliasExistsException',
  NOT_AUTHORIZED_EXCEPTION: 'NotAuthorizedException',
  LIMIT_EXCEEDED_EXCEPTION: 'LimitExceededException',
  RESOURCE_NOT_FOUND_EXCEPTION: 'ResourceNotFoundException',
  USER_NOT_FOUND_EXCEPTION: 'UserNotFoundException'
}
